import { useState } from 'react'
import { DepositPanel } from './DepositPanel'
import { WalletBalances } from './WalletBalances'
import { WalletInfoCSS } from './WalletInfoCSS.styled'
import { WithdrawPanel } from './WithdrawPanel'
import { WalletTransactions } from 'components/Organisms/walletPage/WalletTransactions'

export const WalletInfo = () => {
  const [activeTab, setActiveTab] = useState('deposit')
  return (
    <WalletInfoCSS>
      <div className='wallet_page_wrapper'>
        <h1>Wallet</h1>

        <WalletBalances />
        <div id='wallet_content'>
          {/* <!-- <div className="error_bar">
								We noticed your email address hasn't yet been verified <button>Verify now</button>
							</div> -->	 */}
          {/* <!-- <div className="success_bar">
								<strong>Success!</strong> Your email address is now verified
							</div> -->						 */}
          <div className='wallet_tabs_wrapper'>
            <input
              className='radio'
              id='deposit_tab_one'
              name='wallet_tabs_group_1'
              type='radio'
              checked={activeTab === 'deposit'}
              onChange={() => null}
            />
            <input
              className='radio'
              id='withdraw_tab_two'
              name='wallet_tabs_group_1'
              type='radio'
              checked={activeTab === 'withdraw'}
              onChange={() => null}
            />

            <div className='tabs'>
              <label
                className='wallet_tab_1'
                id='deposit_tab'
                htmlFor='deposit_tab_one'
                onClick={() => setActiveTab('deposit')}
              >
                Deposit
              </label>
              <label
                className='wallet_tab_1'
                id='withdraw_tab'
                htmlFor='withdraw_tab_two'
                onClick={() => setActiveTab('withdraw')}
              >
                Withdraw
              </label>
            </div>

            <div className='wallet_panels_1'>
              <DepositPanel />
              <WithdrawPanel />
              <WalletTransactions activeTab={activeTab} />
            </div>
          </div>
        </div>
      </div>
    </WalletInfoCSS>
  )
}
